import { combineReducers } from 'redux';
import windowDimension from './windowDimension';
import windowLocation from './windowLocation';
import notification from './notice';
import directPlansWindows from './directPlansWindows';
import directPlansAndroid from './directPlansAndroid';
import account from './account';
import subscriptions from './subscriptions';
import msPlans from './msPlans';
import musePlans from './musePlans';
import museTrialPlans from './museTrialPlans';
import museAndroidPromo from './museAndroidPromo';
import subscriptionActivate from './subscriptionActivate';
import redemptionAuth from './redemptionAuth';
import location from './location';
import onBoard from './onBoard';
import i18n from './i18n';
import partnerActivate from './activatePartner';
import communicationPreferences from './communicationPreferences';
import auth, { checkLogout } from './auth';

const reducers = {
  windowDimension,
  windowLocation,
  notification,
  directPlansWindows,
  directPlansAndroid,
  auth,
  account,
  subscriptions,
  msPlans,
  musePlans,
  museTrialPlans,
  museAndroidPromo,
  redemptionAuth,
  location,
  onBoard,
  partnerActivate,
  subscriptionActivate,
  communicationPreferences,
  i18n
};

const appReducer = combineReducers(reducers);

const rootReducer = (state, action) => {
  let appState = state;
  // As one reducer can not update the key values for other reducer keys here we are handling
  // the logout before actual reducers get fired and setting the whole redux store to undefined.
  appState = checkLogout(appState, action);
  return appReducer(appState, action);
};

export default function makeRootReducer() {
  return rootReducer;
}



// WEBPACK FOOTER //
// ./src/redux/reducers/index.js